// import { action } from 'easy-peasy';

import { ICommonModel } from '@/types/store/common';

const commonModel: ICommonModel = {};

export default commonModel;
